// extracted by mini-css-extract-plugin
export default {"overlay":"Gy-z","bodyOpen":"Hy-z","content":"Iy-z","header":"Jy-z","closeNoHeading":"Ky-z"};